import {
  ChangeDetectionStrategy,
  Component,
  effect,
  output,
  Signal,
  signal,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicBoxCategoriesComponent } from '../public-box-categories/public-box-categories.component';
import { SpinnerFilledComponent } from '@web/shared/ui';
import { PublicBoxTileComponent } from '../public-box-tile/public-box-tile.component';
import { PublicBoxDataSourceService } from '../../services/public-box-data-source.service';
import { PublicBoxSearchPanelComponent } from '../public-box-search-panel/public-box-search-panel.component';
import { Observable } from 'rxjs';
import { PublicBoxSortPanelComponent } from '../public-box-sort-panel/public-box-sort-panel.component';
import { PublicBoxSortType } from '../../enums/public-box-sort-type';
import { Nillable } from '@web/utils';
import { PublicBoxesQuery } from '../../models/public-boxes-query';
import { activatedRouteQueryParamAsString, RouteQueryParam } from '@web/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { PublicBox } from '../../models/public-box';

@Component({
  selector: 'app-public-boxes',
  imports: [
    CommonModule,
    PublicBoxCategoriesComponent,
    PublicBoxTileComponent,
    PublicBoxSearchPanelComponent,
    PublicBoxSortPanelComponent,
    SpinnerFilledComponent,
  ],
  templateUrl: './public-boxes.component.html',
  styleUrl: './public-boxes.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxesComponent {
  private readonly publicBoxDataSource = inject(PublicBoxDataSourceService);

  public readonly chooseCategoryEvent = output();

  protected boxes$ = this.boxesSource();

  private readonly phrase = signal<Nillable<string>>(null);
  private readonly sortType = signal<Nillable<PublicBoxSortType>>(null);
  private readonly categorySlug = this.currentCategorySignal();

  public constructor() {
    effect(() => this.reloadBoxesWithQuery());
  }

  public handleSortTypeChange(sortType: Nillable<PublicBoxSortType>): void {
    this.sortType.set(sortType);
  }

  public handlePhraseChangeEvent(phrase: Nillable<string>): void {
    this.phrase.set(phrase);
  }

  public handleChooseCategoryEvent(): void {
    this.chooseCategoryEvent.emit();
  }

  private boxesSource(): Observable<PublicBox[]> {
    return this.publicBoxDataSource.fetchBoxes();
  }

  private reloadBoxesWithQuery(): void {
    this.boxes$ = this.publicBoxDataSource.fetchBoxes(
      new PublicBoxesQuery({
        sortType: this.sortType(),
        categorySlug: this.categorySlug(),
        phrase: this.phrase(),
      }),
    );
  }

  private currentCategorySignal(): Signal<Nillable<string>> {
    return toSignal(
      activatedRouteQueryParamAsString(RouteQueryParam.PL_Category),
    );
  }
}
